import React from 'react'
import { css } from 'aphrodite'
import { Container } from 'reactstrap'

import Sitemap from '../partials/Sitemap'

import style from './style'

const sitemapHeader = [
  { url: '/info', title: 'Info' },
  { url: '/privacy', title: 'Privacy Policy' }
]

export const Privacy = props => {
  return [
    <Sitemap key={0} sitemap={sitemapHeader} />,
    <section key={1} className={css(style.main.section)}>
      <Container>
        <p className={css(style.paragraphs.lead)}>
          This privacy policy discloses the privacy practices for VPP Gaming
          Network. This privacy policy applies solely to information collected
          by this web site. It will notify you of the following:
        </p>
        <ul className={css(style.lists.list)}>
          <li className={css(style.lists.listItem)}>
            What personally identifiable information is collected from you
            through the web site, how it is used and with whom it may be shared.
          </li>
          <li className={css(style.lists.listItem)}>
            What choices are available to you regarding the use of your data.
            The security procedures in place to protect the misuse of your
            information.
          </li>
          <li className={css(style.lists.listItem)}>
            How you can correct any inaccuracies in the information.
          </li>
        </ul>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>
          Information Collection, Use, and Sharing{' '}
        </h2>
        <p className={css(style.paragraphs.p)}>
          We are the sole owners of the information collected on this site. We
          only have access to/collect information that you voluntarily give us
          via email or other direct contact from you. We will not sell or rent
          this information to anyone.
        </p>
        <p className={css(style.paragraphs.p)}>
          We will use your information to respond to you, regarding the reason
          you contacted us. We will not share your information with any third
          party outside of our organization, other than as necessary to fulfill
          your request, e.g. to ship an order.
        </p>
        <p className={css(style.paragraphs.p)}>
          Unless you ask us not to, we may contact you via email in the future
          to tell you about specials, new products or services, or changes to
          this privacy policy.
        </p>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>
          Your Access to and Control Over Information
        </h2>
        <p className={css(style.paragraphs.p)}>
          You may opt out of any future contacts from us at any time. You can do
          the following at any time by contacting us via the email address or
          phone number given on our website:
        </p>
        <ul className={css(style.lists.list)}>
          <li className={css(style.lists.listItem)}>
            See what data we have about you, if any.
          </li>
          <li className={css(style.lists.listItem)}>
            Change/correct any data we have about you.
          </li>
          <li className={css(style.lists.listItem)}>
            Have us delete any data we have about you.
          </li>
          <li className={css(style.lists.listItem)}>
            Express any concern you have about our use of your data.
          </li>
        </ul>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>Security</h2>
        <p className={css(style.paragraphs.p)}>
          We take precautions to protect your information. When you submit
          sensitive information via the website, your information is protected
          both online and offline.
        </p>
        <p className={css(style.paragraphs.p)}>
          Wherever we collect sensitive information (such as credit card data),
          that information is encrypted and transmitted to us in a secure way.
          You can verify this by looking for a closed lock icon at the bottom of
          your web browser, or looking for "https" at the beginning of the
          address of the web page.
        </p>
        <p className={css(style.paragraphs.p)}>
          While we use encryption to protect sensitive information transmitted
          online, we also protect your information offline. Only employees who
          need the information to perform a specific job (for example, billing
          or customer service) are granted access to personally identifiable
          information. The computers/servers in which we store personally
          identifiable information are kept in a secure environment.
        </p>

        <h2 className={css(style.headers.h2)}>
          Cookies &amp; 3rd Party Advertisements
        </h2>
        <p className={css(style.paragraphs.p)}>
          Google, as a third party vendor, uses cookies to serve ads on your
          site. Google's use of the DART cookie enables it to serve ads to your
          users based on their visit to your sites and other sites on the
          Internet. Users may opt out of the use of the DART cookie by visiting
          the{' '}
          <a
            className={css(style.links.link)}
            href='http://www.google.com/policies/technologies/ads/'
            target='_blank'
          >
            Google ad and content network privacy policy
          </a>.
        </p>
        <p className={css(style.paragraphs.p)}>
          We allow third-party companies to serve ads and/or collect certain
          anonymous information when you visit our web site. These companies may
          use non-personally identifiable information (e.g., click stream
          information, browser type, time and date, subject of advertisements
          clicked or scrolled over) during your visits to this and other Web
          sites in order to provide advertisements about goods and services
          likely to be of greater interest to you. These companies typically use
          a cookie or third party web beacon to collect this information. To
          learn more about this behavioral advertising practice or to opt-out of
          this type of advertising, you can visit{' '}
          <a
            className={css(style.links.link)}
            href='http://www.networkadvertising.org/managing/opt_out.asp'
            target='_blank'
          >
            www.networkadvertising.org/managing/opt_out.asp
          </a>.
        </p>

        <hr className={css(style.main.spacer)} />

        <h2 className={css(style.headers.h2)}>Updates</h2>
        <p className={css(style.paragraphs.p)}>
          Our Privacy Policy may change from time to time and all updates will
          be posted on this page.
        </p>
        <p className={css(style.paragraphs.p)}>
          <strong>
            If you feel that we are not abiding by this privacy policy, you
            should contact us immediately via our live chat or contact page.
          </strong>
        </p>
      </Container>
    </section>
  ]
}

export default Privacy



// WEBPACK FOOTER //
// ./src/components/Privacy/index.js